import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-3 md:pt-6 pb-6 md:pb-8 bg-racq-anti-flash-white rounded flex-col justify-start items-start gap-4 flex" }
const _hoisted_2 = { class: "flex-col justify-start items-start gap-0.5 flex" }
const _hoisted_3 = { class: "text-racq-med-grey text-lg-bold" }
const _hoisted_4 = { class: "self-stretch flex-col justify-start items-start gap-5 flex" }
const _hoisted_5 = { class: "self-stretch justify-end items-start gap-4 md:gap-6 flex flex-col md:flex-row" }
const _hoisted_6 = { class: "grow shrink basis-0 justify-start items-end gap-1 flex" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center h-[32px] w-[32px] self-center"
}
const _hoisted_8 = { class: "text-center text-racq-dark-grey text-xl4-bold" }
const _hoisted_9 = { class: "pb-1 justify-start items-center gap-2.5 flex" }
const _hoisted_10 = { class: "text-racq-med-grey text-m" }
const _hoisted_11 = { class: "grow shrink basis-0 flex-col justify-start items-start inline-flex" }

import { computed } from 'vue';
import { Text, RichText, Field, Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import { formatCurrency } from '@/utils/text-transforms';
import Tag from '@/components/Tag/Tag.vue';
import { TagTypes, TagSize, TagBorderColour, TagBgColour } from '@/enums/tag-enums';
import { IQuote, PaymentFrequency } from '@/interfaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteSummary',
  props: {
    fields: {},
    quote: {},
    coverageLabel: {}
  },
  setup(__props: any) {

const props = __props;

const quoteRefText = computed(() => props.fields.quoteRefText.value.replace('{{quoteRef}}', props.quote.reference!));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Text), {
          field: _ctx.fields.title
        }, null, 8, ["field"])
      ]),
      _createVNode(_unref(RichText), {
        field: { value: _ctx.coverageLabel },
        class: "text-racq-med-grey text-base"
      }, null, 8, ["field"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.fields.icon?.value?.src)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(Image), {
                  media: _ctx.fields.icon
                }, null, 8, ["media"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.quote.paymentFrequency === _unref(PaymentFrequency).Monthly
                ? _unref(formatCurrency)(_ctx.quote.insuranceQuoteSummary?.monthlyDeposit ?? 0, 2)
                : _unref(formatCurrency)(_ctx.quote.insuranceQuoteSummary?.yearlyAnnualPremium ?? 0, 2)), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.quote.paymentFrequency === _unref(PaymentFrequency).Monthly ? _ctx.fields.monthly.value : _ctx.fields.annually.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(Tag, {
            tagText: quoteRefText.value,
            tagType: _unref(TagTypes).noIcon,
            tagSize: _unref(TagSize).lg,
            tagBgColour: _unref(TagBgColour).trueWhite,
            tagBorderColour: _unref(TagBorderColour).lightblue
          }, null, 8, ["tagText", "tagType", "tagSize", "tagBgColour", "tagBorderColour"])
        ])
      ])
    ])
  ]))
}
}

})